'use strict';

var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../../DesignSystem/Styles/withStyles.js');
require('prop-types');
var Star = require('../../../../IconsAndImages/Icons/Star.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  ratingText: {
    fontSize: '16px',
    position: 'relative',
    bottom: 1,
    color: '#212121',
    margin: '0 10px 0 -2px'
  },
  starPosition: {
    position: 'relative',
    top: 2
  }
};

var RatingChipContent = function RatingChipContent(_ref) {
  var classes = _ref.classes,
      rating = _ref.rating;
      objectWithoutProperties(_ref, ["classes", "rating"]);

  return React__default["default"].createElement("span", {
    className: classes.ratingText
  }, rating.toFixed(2), " ", React__default["default"].createElement(Star, {
    size: "small",
    className: classes.starPosition
  }));
};

var RatingChipContent$1 = withStyles["default"](styles)(RatingChipContent);

module.exports = RatingChipContent$1;
